// SOURCE OF A TRACKED EVENT VIA MIXPANEL

// Element addition sources
export const SIDEBAR = 'Sidebar';
export const DUPLICATE = 'Duplicate';
export const PASTE = 'Paste';

// Layer reordering sources
export const ARROWS = 'Arrows';
export const DRAG = 'Drag';

// Section saving sources
export const ACTIONS = 'Actions';

// Image addition sources
export const UPLOAD = 'Upload';
export const LIBRARY = 'Library';
export const URL = 'URL';

// Undo/Redo sources
export const BUTTON = 'Button';
export const KEYBOARD = 'Keyboard';
